
import Vue from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'vue-multiselect/dist/vue-multiselect.min.css'// 多选框组件css
import '@/assets/styles/index.scss' // global css
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import App from './App'
import router from './router'
import store from './store'
import api from './service/api' // 全部api
import api_proj from './service/api_proj' // 全部api
import eComponents from './components/index'
import '@/assets/images/icons' // icon
import '@/permission' // permission control
import fetchData from '@/service/fetch'
import cache from  './service/cache'
import * as filters from './filters/index'
window.Vue = Vue
import VCalendar from 'v-calendar'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 5
})

ElementUI.Dialog.props.closeOnClickModal.default=false;
Vue.use(ElementUI, { locale,size: 'small' })
Vue.use(eComponents)
Vue.use(VueAwesomeSwiper)
Vue.use(VCalendar)


Object.keys(filters).forEach((key)=>{
    Vue.filter(key,filters[key])
})
Vue.prototype.VUE_APP_SITE=process.env.VUE_APP_SITE||'';
Vue.prototype.VUE_APP_REPORT=process.env.VUE_APP_REPORT||'';
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$api_proj = api_proj
Vue.prototype.$fetchData = fetchData
Vue.prototype.$cache=cache
Vue.prototype.routerLink = function () {
    let params = {};
    let path = arguments[0] ? arguments[0] : null;
    params['type'] = arguments[1] ? arguments[1] : null;
    params['id'] = arguments[2] ? arguments[2] : 0;
    let obj = arguments[3] ? arguments[3] : null;

    if (obj != null) {
        if (typeof obj == "object") {
            for (let key in obj) {
                params[key] = obj[key];
            }
        } else {
            throw new Exception("路由链接函数第四个参数只支持object类型");
        }
    }
    console.log(params)
    console.log(arguments)
    router.push(
        {
            path: path,
            query: params
        }
    )
},
Vue.prototype.$btnVisiable=function (btnKey) {
    let allMenu = this.$store.getters.allMenus;
    for (let i = 0; i < allMenu.length; i++) {
        if (allMenu[i].url === btnKey) {
            if (allMenu[i].isShow == 1) {
                return true;
            } else {
                return false;
            }

        }
    }
    return false;
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app")